import {
  Button as AntButton,
  Col,
  Row,
  Typography,
  Modal,
  Card,
  Select,
  Input as AntInput,
  DatePicker,
  Upload,
  Icon,
  Popconfirm,
  message,
  Tag,
  Layout,
  Button,
} from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ReactTable from 'react-table';
import CreateNewUserAccount from '../../components/hospital_dashboard/createNewUserAccount';
import { getExistingUsers } from '../../services/api/hospitalDashboard';
import { FaEdit } from 'react-icons/fa'
import DashboardUserEditModal from '../common/DashboardUserEditModal';
class HospitalDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      usersData: [],
      totalRecords: 0,
      editModal: false,
      editModalData: null,
      newUserModal: false,
      editUserId: null,
      editUserDetails: {}
    };
  }

  componentDidMount() {
    this.fetchExistingUsersAccount(this.props.centerId);
  }

  fetchExistingUsersAccount = (centerId) => {
    return getExistingUsers(centerId)
      .then((response) => {
        this.setState({
          usersData: response.body.data,
        });
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => { });
  };

  editVaccineDetails = (row) => {
    console.log(row, 'row');
    this.setState({
      editModal: true,
      editModalData: row.original,
    });
  };

  openNewUserModal = () => {
    this.setState({
      newUserModal: true,
    });
  };

  getColums = () => [
    {
      Header: 'Existing Hospital Dashboard Users',
      columns: [
        {
          Header: 'Name',
          accessor: 'name',
          Cell: (row) => {
            return row.original.name;
          },
        },
        {
          Header: 'Email',
          accessor: 'email',
          Cell: (row) => {
            return row.original.email;
          },
        },
        {
          Header: 'Phone',
          accessor: 'phone',
          Cell: (row) => {
            return row.original.phone;
          },
        },
        {
          Header: 'User Name',
          accessor: 'userName',
          filterable: false,
          Cell: (row) => {
            return row.original.userName;
          },
        },
        {
          Header: 'Spoc Name',
          accessor: 'spocName',
          filterable: false,
          Cell: (row) => {
            return row.original.spocName;
          },
        },
        {
          Header: 'Spoc Id',
          accessor: 'spocId',
          filterable: false,
          Cell: (row) => {
            return row.original.spocId;
          },
        },
        {
          Header: 'Role',
          accessor: 'role',
          filterable: false,
          Cell: (row) => {
            return row.original.role;
          },
        },
        {
          Header: 'Active',
          accessor: 'active',
          filterable: false,
          Cell: (row) => {
            return Boolean(row.original.active) ? 'Yes' : 'No'
          }
        },
        {
          Header: 'Opd',
          accessor: 'opd',
          filterable: false,
          Cell: (row) => {
            return Boolean(row.original.isOpdCenter) ? 'Yes' : 'No'
          }
        },
        {
          Header: 'Physio',
          accessor: 'physio',
          filterable: false,
          Cell: (row) => {
            return Boolean(row.original.isPhysioCenter) ? 'Yes' : 'No'
          }
        },
        {
          Header: 'Dental',
          accessor: 'dental',
          filterable: false,
          Cell: (row) => {
            return Boolean(row.original.isDentalCenter) ? 'Yes' : 'No'
          }
        },
        {
          Header: 'Action',
          filterable: false,
          Cell: (row) => {
            const { id } = row.original
            return <FaEdit
              style={{ cursor: 'pointer' }}
              onClick={() => this.setState({
                editUserId: id,
                editUserDetails: row.original
              })}
            />
          }
        }
      ],
    },
  ];

  render() {
    return (
      <>
        <AntButton onClick={this.openNewUserModal} type="primary">
          Create New User
        </AntButton>
        <Layout style={{ marginTop: 20 }}>
          {this.state.newUserModal === true && (
            <CreateNewUserAccount
              modalIsOpen={this.state.newUserModal}
              handleClose={() => {
                this.setState({ newUserModal: false });
              }}
              reload={() => this.fetchExistingUsersAccount(this.props.centerId)}
              centerId={this.props.centerId}
            />
          )}
          <Row>
            <ReactTable
              data={this.state.usersData}
              columns={this.getColums()}
              showPaginationTop
              showPaginationBottom
              loading={this.state.loading}
            />
          </Row>
        </Layout>
        <DashboardUserEditModal
          id={this.state.editUserId}
          updates={this.state.editUserDetails}
          onClose={() => this.setState({ editUserId: null, editUserDetails: {} })}
          onComplete={() => this.fetchExistingUsersAccount(this.props.centerId)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
});

export default withRouter(connect(mapStateToProps)(HospitalDashboard));
